module.exports = __WEBPACK_EXTERNAL_MODULE_16__;


//////////////////
// WEBPACK FOOTER
// external {"root":"ReactDOM","commonjs":"react-dom","commonjs2":"react-dom","amd":"react-dom"}
// module id = 16
// module chunks = 0